module.exports = __webpack_public_path__ + "afdfc66a2f1fe7bece520c8838120878.svg";